import { MultiLangStr } from '../model/multi-lang-str.model';

/**
 * Get the appropriate language content from a MultiLangStr object
 * Falls back to English if the requested language is not available
 */
export const getLanguageContent = (
  multiLangStr: MultiLangStr,
  language: string,
): string => {
  if (!multiLangStr) return '';

  // Try to get content in the requested language
  const content = multiLangStr[language as keyof MultiLangStr];
  if (content) return content;

  // Fallback to English
  return multiLangStr.en || '';
};
